import {
  Button,
  DialogProps,
  FormHelperText,
  Stack,
  Dialog,
  DialogActions,
  DialogContent,
} from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useEffect } from 'react'
import { usePrevious } from 'react-use'
import { useMutation } from '@apollo/client'
import { AddCashRegisterActivationCodeDocument } from '../../../generated/graphql'
import { ActivationCodeBlock } from './activation-code-block'

type Props = DialogProps & {
  registerId: string
  onClose(): void
}

export const ActivationCodeDialog = (props: Props) => {
  const { t } = useTranslation(['cash_registers', 'shared'])
  const { registerId, onClose, ...dialogProps } = props
  const prevOpen = usePrevious(props.open)

  const [requestActivationCode, { data, loading }] = useMutation(
    AddCashRegisterActivationCodeDocument,
    { variables: { registerId } },
  )

  const splitBySpace = (value: string) => value.replace(/(.{4})/, '$1' + ' ')

  const account = data?.addCashRegisterActivationCode.account
  const activationCode = data?.addCashRegisterActivationCode.activationCode
  const displayActivationCode = activationCode && splitBySpace(activationCode)

  useEffect(() => {
    if (props.open && !prevOpen) {
      void requestActivationCode()
    }
  }, [props.open, prevOpen, requestActivationCode])

  return (
    <Dialog onClose={onClose} maxWidth="xs" {...dialogProps}>
      <DialogContent sx={{ mt: 3, mb: 1 }}>
        <Stack gap={3}>
          <ActivationCodeBlock
            loading={loading}
            title={t('cash_registers:activation_code.account')}
            value={account}
          />

          <ActivationCodeBlock
            loading={loading}
            title={t('cash_registers:activation_code.activation_code')}
            value={displayActivationCode}
          />
        </Stack>

        <FormHelperText>
          {t('cash_registers:activation_code.description')}
        </FormHelperText>
      </DialogContent>

      <DialogActions>
        <Button color="primary" onClick={onClose}>
          {t('shared:action.close')}
        </Button>
      </DialogActions>
    </Dialog>
  )
}
